export default {
  blank: () => import("/home/runner/work/parmazip-patient/parmazip-patient/src/layouts/Blank.vue").then(m => m.default || m),
  "patient-dashboard": () => import("/home/runner/work/parmazip-patient/parmazip-patient/src/layouts/PatientDashboard.vue").then(m => m.default || m),
  default: () => import("/home/runner/work/parmazip-patient/parmazip-patient/src/layouts/default.vue").then(m => m.default || m)
}